module.exports = __webpack_public_path__ + "img/Icon_garantie-01.483a5bff.png";